
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCuwIlD0hRlNssxnpOXMd2xQ_X5SOKez_U",
  authDomain: "sitecomments-24ec8.firebaseapp.com",
  projectId: "sitecomments-24ec8",
  storageBucket: "sitecomments-24ec8.firebasestorage.app",
  messagingSenderId: "868365238175",
  appId: "1:868365238175:web:d72ca5a04b3c5adf4607aa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);